export default __webpack_public_path__ + "static/media/student-list-search.84123407.svg";